module.exports = __webpack_public_path__ + "assets/img/sweetbot-mobilebanner.47045ef6.png";